import useLoading from "../../control/loading/useLoading"
import useCallApi from "../../utilities/axios"
import { getVerifyDocumentHistory } from "./webServiceURL"

const useVerifyDocument = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()
    
    const getVerifyHistory = async (submittedId: number, submittedTypeId: number) => {
        try {
            loadingHook.loadingOpen()
            const apiUrl = `${getVerifyDocumentHistory}/${submittedId}/${submittedTypeId}`
            const { data } = await callApi.axiosGet({
                url: apiUrl
            })
            return data
        } catch(error) {
            /** Must Not Empty */
        } finally {
            loadingHook.loadingClose()
        }
    }

    return {
        getVerifyHistory
    }
}

export default useVerifyDocument